<template>
    <div class="loader">
        <b-container>
            <b-row>
                <b-col cols="2"></b-col>
                <b-col cols="8">
                    <b-card bg-variant="danger" text-variant="light">
                        <font-awesome-icon icon="exclamation-triangle" size="4x"></font-awesome-icon>

                        <div>{{$t('app.errorLoadingApp')}}</div>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'errorMainApp',
  components: { FontAwesomeIcon }
};
</script>

<style scoped lang="scss">
    .loader {
        position: absolute;
        top: 50%;
        width: 100%;
        text-align: center;
        transform: translateY(-50%);

    }
</style>
